<script lang="ts" setup>
import { usePrevioDS } from '../../composables/helpers'
import { PGlobalMenuItem, PGlobalMenuWithSubMenu } from './types'
import PGlobalMenuDropdown from './PGlobalMenuDropdown.vue'
import PSideMenu from './PSideMenu.vue'

type Props = {
  items: (PGlobalMenuWithSubMenu | PGlobalMenuItem)[]
}

type Emits = {
  (e: 'closeMobile'): void
}

const openMobileMenu = defineModel<boolean>('openMobileMenu')

withDefaults(defineProps<Props>(), {})

const emit = defineEmits<Emits>()

const ds = usePrevioDS()

const close = (): void => {
  emit('closeMobile')
}
</script>

<template>
  <template v-if="ds.screen().isLaptopAndLarge">
    <div class="p-display-flex">
      <p-global-menu-dropdown
        v-for="menuWithSubMenu in items"
        :key="items.indexOf(menuWithSubMenu)"
        :menu="menuWithSubMenu"
      />
    </div>
  </template>

  <p-side-menu v-else v-model="openMobileMenu" :items="items" @close="close">
    <template v-if="$slots['side-menu-actions']" #side-menu-actions>
      <slot name="side-menu-actions" />
    </template>

    <template v-if="$slots['side-menu-item']" #side-menu-item="{ item }: { item: PGlobalMenuItem }">
      <slot name="side-menu-item" :item="item" />
    </template>

    <template v-if="$slots['side-menu-footer']" #side-menu-footer>
      <slot name="side-menu-footer" />
    </template>
  </p-side-menu>
</template>
